import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium transition-colors",
  {
    variants: {
      variant: {
        default: "bg-brand-100 text-brand-800",
        veterinario: "bg-emerald-100 text-emerald-800",
        auxiliar: "bg-blue-100 text-blue-800",
        ambos: "bg-purple-100 text-purple-800",
        apoio: "bg-amber-100 text-amber-800",
        admin: "bg-orange-100 text-orange-800",
        ativo: "bg-green-100 text-green-800",
        inativo: "bg-slate-200 text-slate-600",
        outline: "border border-slate-300 text-slate-700",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
